var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.classname,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","viewBox":"0 0 21 20"}},[_c('path',{attrs:{"d":"M9.50006 11V17H11.5001V11H17.5V9H11.5001V3H9.50006V9H3.5V11H9.50006Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }